<template>
  <b-card-actions action-collapse title="B/L list">
     <b-row> 
      <b-col md="12">
    
        
    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />

          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row>  
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      class="bl-tab"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
            <!-- Column: Cargo Details -->
            <span v-if="props.column.field === 'cargo'">
          <b-button class="detail-button" v-b-modal="'cargoDetails'" @click="updateCargo(props.row.cargoDetails)">View Details</b-button>
        </span>
        <!-- Column: Parties -->
          <span v-if="props.column.field === 'party'">
          <b-button class="detail-button" v-b-modal="'parties'" @click="updateParties(props.row.parties)">View Details</b-button>
        </span>
        <span v-else-if="props.column.field == 'pdfFile'">
        <div class="file">
          <b-form-file
            placeholder ="PDF"
            type="file"
            v-model="file"
            name="file"
            accept=".pdf"
          ></b-form-file>
          <b-button size="sm" variant="gradient-primary" class="file-button" @click="uploadFile(props.row._id)">
            <feather-icon icon="SaveIcon" size="18"/>
          </b-button>
        </div>
        <b-button size="sm" class="mt-1 f-right" v-if="props.row.pdf" @click="downloadFile(props.row.pdf)"> <feather-icon icon="DownloadIcon" size="18"/></b-button>
      </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>

<!-- 
            <b-dropdown-item @click="updateBl(props.row._id)">
                <feather-icon icon="CheckIcon" class="mr-50" />
                <span><router-link :to="`/sale/quotations?customer=${props.row._id}`">Accept</router-link></span>
              </b-dropdown-item>
      <b-dropdown-item @click="updateBl(props.row._id)">
                <feather-icon icon="XIcon" class="mr-50" />
                <span><router-link :to="`/sale/quotations?customer=${props.row._id}`">Decline</router-link></span>
              </b-dropdown-item> -->
          <b-dropdown-item @click="deleteBooking(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete B/L</span>
              </b-dropdown-item>
            <b-dropdown-item @click="updateBl(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span><router-link :to="`/bl/edit?id=${props.row._id}`">Update B/L</router-link></span>
            </b-dropdown-item>
            <b-dropdown-item @click="detailBooking(props.row.booking._id)">
                <feather-icon icon="ExternalLinkIcon" class="mr-50" />
                <span>Detail booking</span>
            </b-dropdown-item>
              
            </b-dropdown>
          </span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal id="cargoDetails" size="xl" hide-footer centered  title="Cargo Details"><cargo :data="cargoData"></cargo></b-modal>
    <b-modal id="parties" size="xl" hide-footer centered  title="Parties"><parties :data="partiesData"></parties></b-modal>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import cargo from './CargoDetails.vue'
import parties from './Parties.vue'
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
  BFormFile
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    cargo,
    parties,
    BFormFile
  },
  data() {
    return {
      file : null,
      json_data: [],
      json_fields: {
        society: "society",
        Nom: "firstName",
        Prenom: "lastName",
        Email: "email",
        Cite: "city",
        numero: "telNumbers",
        "Matricule Fiscale": "registrationNumber",
      },
      pageLength: 5,
      dir: false,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        /*{
          label: "State",
          field: "state",
          filterOptions: {
            enabled: true,
            placeholder: "State",
          },
        },*/
        {
          width: '300px',
          label: "BL PDF",
          field: "pdfFile",
        }, 
        {
          width: '180px',
          label: "Booking",
          field: "booking.reference",
          filterOptions: {
            enabled: true,
            placeholder: "Search Reference",
          },
        },
        {
          width: '180px',
          label: "Document Type",
          field: "documentType",
          filterOptions: {
            enabled: true,
            placeholder: "Search Document Type",
          },
        },
        {
          width: '260px',
          label: "Deliver the Bill of Lading",
          field: "receiverAgent",
          filterOptions: {
            enabled: true,
            placeholder: "Search Deliver the Bill of Lading",
          },
        },
        {
          width: '210px',
          label: "Cargo Details",
          field: 'cargo',
        },
        {
          width: '160px',
          label: "Parties",
          field: "party",
        },
        {
          width: '170px',
          label: "Payment Name",
          field: "payment.paymentName",
          filterOptions: {
            enabled: true,
            placeholder: "Search Payment Name",
          },
          formatFn: value => value.toUpperCase()
        },
        {
          width: '170px',
          label: "Payment Type",
          field: "payment.paymentType",
          filterOptions: {
            enabled: true,
            placeholder: "Search Payment Type",
          },
        },
        {
          width: '190px',
          label: "Payment Country",
          field: "payment.paymentCountry",
          filterOptions: {
            enabled: true,
            placeholder: "Search Payment Country",
          },
        },
        {
          width: '190px',
          label: "Invoice details",
          field: "payment.invoiceDetails",
          filterOptions: {
            enabled: true,
            placeholder: "Search Invoice details",
          },
        },
        
      ],
      rows: [],
      searchTerm: '',
      disabled: true,
      cargoData : [],
      partiesData: [],
    };
  },
  watch: {
    '$route.query.id': 'getAllDataBL',
  }, 
  async created() {
    await this.getAllDataBL();
  },
  methods: {
    async getAllDataBL() {
      if (this.$route.query.id) {
        await axios.get("https://mtl-feeder-nodejs.onrender.com/api/bls?user=" +this.$route.query.id)
        .then((response) => {
          this.rows = response.data.data.reverse();
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }
      else {
        await axios.get("https://mtl-feeder-nodejs.onrender.com/api/bls")
        .then((response) => {
          this.rows = response.data.data.reverse();
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
      }
    },
    updateCargo(cargo) {
      this.cargoData = cargo
    },
    updateParties(data) {
      this.partiesData = Object.entries(data).map(([groupName, groupData]) => ({
            groupName,
            groupData
        })); 
    },
    async uploadFile(id) {
      if (!this.file) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Please select a file`,
            icon: "UserIcon",
            variant: "warning",
          },
        });      
      }
      else {
        const allowedExtensions = ['.pdf'];
        const fileExtension = this.file.name.slice(this.file.name.lastIndexOf('.'));
        if (!allowedExtensions.includes(fileExtension)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `PDF file only`,
              icon: "UserIcon",
              variant: "warning",
            },
          }); 
        }
        else {
          const formData = new FormData();
          formData.append("pdf",this.file)
          try {
            const response = await axios.put(`https://mtl-feeder-nodejs.onrender.com/api/bls/${id}`, formData ,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              });
              this.getAllDataBL()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `File submitted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });             
            } catch (error) {
              console.error(error);
            }
        }
      }
    },
    downloadFile(url) {
      axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = "File.pdf";  
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    deleteBooking(id) {
      this.$swal({
        title: "you really want to delete this BL ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm !",
        cancelButtonText: "Decline !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios.put(`https://mtl-feeder-nodejs.onrender.com/api/bls/${id}`, { active : false }
          )
            .then((response) => {
              this.getAllDataBL();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Bl deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error during delete`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action canceled",
            icon: "error",
            confirmButtonText: "Close !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    updateBl(id) {
       var routerLink = "/bl/edit?id=" + id;
      this.$router.replace(routerLink);
    },
    detailBooking(id) {
      var routerLink = "/bl/booking-detail?id=" + id;
      this.$router.replace(routerLink);
    },
    advanceSearch(val) {
      this.searchTerm = val;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style>
.bl-tab .vgt-table.bordered td {
  text-align: center;
  vertical-align: middle !important;
}
.bl-tab .vgt-table.bordered td:last-child {
  text-align: left;
}
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}

.btn-delete-all {
  margin-left: 3%;
}
.detail-button {
  border: 1px solid #6e6b7b !important;
  color: #6e6b7b !important;
  background-color: transparent !important;
  border-radius: 3px !important;
  font-weight: bold !important;
}
.detail-button:active,.detail-button:hover {
  color: #6e6b7b !important;
  background-color: transparent !important;
}
.file {
  display: flex;
  align-items: center;
}
.file-button {
  margin-left: 10px;
}
</style>
